// Pure mapping of a scheduler's `calendarSync.state` to a human-readable badge
// label, plus whether the creator's manual-sync action is still meaningful.
//
// Extracted from SchedulerPage's inline label ladder so the new "UNLINKED"
// state (written when the creator disconnects their Google Calendar) renders a
// friendly "Disconnected" label instead of the raw enum, and so the manual-sync
// button can be disabled once syncing is no longer possible (the OAuth token is
// revoked on unlink, so a manual sync would only fail).

/**
 * @param {string|null|undefined} state - scheduler.calendarSync.state
 * @returns {string} human label
 */
export function calendarSyncLabel(state) {
  switch (state) {
    case "OK":
    case "SYNCED":
      return "Synced";
    case "RESCHEDULED":
      return "Rescheduled";
    case "EXTENDED":
      return "Extended";
    case "SHORTENED":
      return "Shortened";
    case "CANCELLED":
      return "Cancelled";
    case "TITLE_UPDATED":
      return "Title updated";
    case "UNLINKED":
      return "Disconnected";
    case "ERROR":
      return "Sync error — retry";
    default:
      // No state yet → the creator has sync enabled but nothing has synced.
      if (!state) return "Sync enabled";
      // Unknown future state: show it verbatim rather than swallowing it.
      return state;
  }
}

/**
 * Whether the creator's manual-sync button should be actionable. Once the
 * calendar is unlinked there is no valid token to sync with, so the button must
 * be disabled/replaced.
 *
 * @param {string|null|undefined} state - scheduler.calendarSync.state
 * @returns {boolean}
 */
export function isCalendarSyncActionable(state) {
  return state !== "UNLINKED";
}
